import format from 'date-fns/format'
import {formatDistanceToNow} from "date-fns";

const dateFormat = "dd/MM/yyyy"
const dateAndTimeFormat = "dd/MM/yyyy HH:mm:ss"
const timeFormat = "HH:mm:ss"
const preFillFormDateAndTimeFormat = "yyyy-MM-dd\'T\'HH:mm"

function normalizeDate(date: any) {
    if(date == undefined) {
        // Default to epoch to prevent nullability issues
        return new Date(0)
    }
    if (typeof date === "number") {
        return new Date(date * 1000)
    }
    return new Date(date)
}

export function formatDate(date: any) {
    return format(normalizeDate(date), dateFormat)
}

export function formatDateAndTime(date: any) {
    return format(normalizeDate(date), dateAndTimeFormat)
}

export function preFillFormDateAndTime(date: any) {
    return format(normalizeDate(date), preFillFormDateAndTimeFormat)
}

export function formatTime(date: any) {
    return format(normalizeDate(date), timeFormat)
}

export function formatTimeUntil(date: any) {
    return formatDistanceToNow(normalizeDate(date))
}
